import React, { useState } from 'react'
import { Box, Button, Grid, IconButton, Modal } from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { Delete as DeleteIcon } from '@material-ui/icons'
import esLocale from 'date-fns/locale/es'
import { format } from 'date-fns'
import { useDispatch } from 'react-redux'
import { patchAnalystInfo } from './state/analystTrackSlice'
interface Props {
  user: any
  isOpen: boolean
  onCancel: () => void
}

const EditStagesAnalystModal: React.FC<Props> = ({ user, isOpen, onCancel }) => {
  const dispatch = useDispatch()
  const [studyDateInput, setStudyDateInput] = useState<Date | null>(user.studyDate)

  const handleSubmit = async (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault()
    dispatch(
      patchAnalystInfo({
        stages: {
          studyDate: studyDateInput ? format(studyDateInput, 'yyyy/MM/dd') : ''
        },
        userId: user._id
      })
    )
    onCancel()
  }

  // const handleSuccess = async (e: React.FormEvent<HTMLButtonElement>) => {
  //   e.preventDefault()
  //   onSuccess()
  // }

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          setStudyDateInput(user.studyDate)
          onCancel()
        }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onSubmit={handleSubmit}
      >
        <form className="form modal_form_edit_stages">
          <Box>Editar fechas: </Box>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <br />
            <Grid container>
              <Grid item xs={11}>
                <DatePicker
                  style={{ width: '100%' }}
                  inputVariant="outlined"
                  label="Fecha de estudio"
                  placeholder="fecha"
                  emptyLabel=""
                  clearable
                  format="yyyy/MM/dd"
                  invalidDateMessage="Fecha incorrecta"
                  value={studyDateInput}
                  onChange={(e: Date | null) => {
                    setStudyDateInput(e)
                  }}
                />
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  style={{
                    color: '#ff6900',
                    width: '100%'
                  }}
                  onClick={() => {
                    setStudyDateInput(null)
                  }}
                >
                  <DeleteIcon style={{ width: '20px' }} />
                </IconButton>
              </Grid>
            </Grid>
            <br />
          </MuiPickersUtilsProvider>
          <Grid container>
            <Grid item xs style={{ textAlign: 'center' }}>
              <Button
                style={{ marginTop: '20px', marginBottom: '10px' }}
                variant="contained"
                onClick={() => {
                  setStudyDateInput(null)
                  onCancel()
                }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs style={{ textAlign: 'center' }}>
              <Button
                style={{ marginTop: '20px', marginBottom: '10px' }}
                type="submit"
                variant="contained"
                color="primary"
                disabled={!studyDateInput}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal>
    </>
  )
}

export default EditStagesAnalystModal
